import ExitDialog from "@Components/game/exit-dialog";
import { HeaderButton } from "@Components/game/header/styled-components";
import TrainingPlanStatusCapsule from "@Components/game/header/training-plan-status-capsule";
import HapticsButtonWrapper from "@Components/generic/haptics-button-wrapper";
import Icon from "@Components/generic/icon";
import { faPowerOff, IconDefinition } from "@fortawesome/pro-solid-svg-icons";
import { VRHeaderButtonAction } from "@Globals/types";
import { useGlobalContext } from "@hooks/index";
import { Button, Stack, useTheme } from "@mui/material";
import { useState } from "react";

export interface HeaderAltButton {
  icon: IconDefinition;
  onClick: () => void;
}

export interface IHeaderRightSection {
  altButtons?: HeaderAltButton[];
  actions?: VRHeaderButtonAction[];
}

const HeaderRightSection = ({ altButtons, actions = [] }: IHeaderRightSection) => {
  const { globalState } = useGlobalContext();
  const theme = useTheme();
  const [showExitDialog, setShowExitDialog] = useState(false);

  return (
    <>
      <Stack direction="row" spacing={2} alignItems="center">
        {actions.map((action, index) => (
          <Button
            key={index}
            onClick={action.onClick}
            color={action.color}
            disabled={action.disabled || false}
            size="small"
            data-shape="pill"
            sx={{
              ...action.sx,
            }}
          >
            {action.label}
          </Button>
        ))}

        <TrainingPlanStatusCapsule />

        {altButtons?.map((button: HeaderAltButton, index: number) => (
          <HapticsButtonWrapper key={index}>
            <HeaderButton onClick={button.onClick}>
              <Icon icon={button.icon} color={theme.palette.dsBase.v200} fontSize={24} />
            </HeaderButton>
          </HapticsButtonWrapper>
        ))}

        {globalState.user.isSuperAdmin && (
          <HapticsButtonWrapper>
            <HeaderButton onClick={() => setShowExitDialog(true)}>
              <Icon icon={faPowerOff} color={theme.palette.dsBase.v200} fontSize={24} />
            </HeaderButton>
          </HapticsButtonWrapper>
        )}
      </Stack>

      {showExitDialog && <ExitDialog open={showExitDialog} onClose={() => setShowExitDialog(false)} />}
    </>
  );
};

export default HeaderRightSection;
